import React from 'react'

export function setDeepKey(_obj, path, value) {
    const obj = Object.assign({}, _obj)
    const pList = path.replace(/\[/g, '.').replace(/\]/g, '').split('.');
    const key = pList.pop();
    const pointer = pList.reduce((accumulator, currentValue) => {
        if (accumulator[currentValue] === undefined) accumulator[currentValue] = {};
        return accumulator[currentValue];
    }, obj);
    pointer[key] = value;
    return obj;
}

export function getDeepKey(_obj, path) {
    const obj = Object.assign({}, _obj)
    const pList = path.replace(/\[/g, '.').replace(/\]/g, '').split('.');
    const key = pList.pop();
    const pointer = pList.reduce((accumulator, currentValue) => {
        if (!accumulator) return {}
        if (accumulator[currentValue] === undefined) accumulator[currentValue] = {};
        return accumulator[currentValue];
    }, obj);
    return pointer[key]
}


export default function useForm({ initialValues = {}, schema, onSubmit }) {
    const [data, setData] = React.useState(initialValues) 
    const [errors, setErrors] = React.useState({}) 

    function setFieldValue(path, value) {
        if (getError(path)) {
            setErrors(
                setDeepKey(errors, path, null)
            )
        }
        setData(
            setDeepKey(data, path, value)
        )
    }

    async function validate(shouldSetErrors=true) {
        if (!schema || typeof schema.validate === 'undefined' || !schema.validate) {
            return true
        }
        try {
            await schema.validate(data, { abortEarly: false })
        } catch (e) {
            const result = e.inner.reduce((acc, cur) => {
                return setDeepKey(acc, cur.path, cur.message)
            }, {})
            if (shouldSetErrors) {
                setErrors(result)
                return false
            } else {
                return result
            }
        }

        if (shouldSetErrors) {
            setErrors({})
            return true
        } else {
            return {}
        }
    }

    async function handleSubmit(e) {
        typeof e === 'object' && e.preventDefault && e.preventDefault()
        typeof e === 'object' && e.stopPropagation && e.stopPropagation()
        const result = await validate()

        if (!result) {
            return false
        } 

        return onSubmit(data)
    }

    function getError(key) {
        if (!errors || Object.keys(errors).length === 0) {
            return null
        }
        const error = getDeepKey(errors, key)
        if (!error) {
            return null
        }
        return error
    }

    return {
        data,
        setData,
        errors,
        setFieldValue,
        validate,
        handleSubmit,
        resetErrors: () => setErrors({}),
        setErrors,
        getError,
    }
}
